module.exports = __webpack_public_path__ + "static/purple-8386102270ba79d72208b236271bb751.svg";